import React, { useEffect, useState } from 'react';

import { Button } from '@infoods/lifebase-ui';
import RefreshIcon from '@mui/icons-material/Refresh';

import { chatService } from '../../../services/chatService';

type RefreshButtonProps = {
  className?: string;
};

const RefreshButton = ({ className }: RefreshButtonProps) => {
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    refreshUsers();
  }, []);

  const refreshUsers = async () => {
    setIsLoading(true);
    try {
      await chatService.refreshUsers();
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Button
      className={className}
      onClick={refreshUsers}
      loading={isLoading}
      loadingPosition="start"
      startIcon={<RefreshIcon />}
      variant="contained"
      size="small"
    >
      Refresh
    </Button>
  );
};

export { RefreshButton };
